import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { isODataResult, ODataResult } from '@app/components/machine-infos/o-data-result.type';


@Injectable()
export class ODataTransformerInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
        return next.handle(request).pipe(
            map(response => {
                if (response instanceof HttpResponse && isODataResult(response.body)) {
                    const oDataObject = response.body as ODataResult<any>;
                    if ('results' in oDataObject.d && oDataObject.d.results instanceof Array) {
                        const results = oDataObject.d.results as any[];
                        for (const result of results) {
                            this.removeMetaDataAndTransformObjectKeys(result);
                        }
                        return new HttpResponse<any>({
                            ...response,
                            body: results
                        });
                    } else {
                        const result = oDataObject.d;
                        this.removeMetaDataAndTransformObjectKeys(result);
                        return new HttpResponse<any>({
                            ...response,
                            body: result
                        });
                    }
                }
                return response;
            }));
    }

    /**
     * Removes __metadata from a given OData object and renames the object keys to camelCase instead of PascalCase
     * Be careful, this method modifies the given object itself - IT DOES NOT COPY IT!
     *
     * @param object the object to modify
     */
    private removeMetaDataAndTransformObjectKeys(object: any): void {
        delete object.__metadata;
        for (const key of Object.keys(object)) {
            delete Object.assign(object, { [key.charAt(0).toLowerCase() + key.slice(1)]: object[key] })[key];
        }
    }
}
